import { Link } from "react-router-dom";
import { clues } from "@/mocks/clues";

const trustPoints = [
  { icon: "ri-user-forbid-line", text: "默认匿名，无需注册" },
  { icon: "ri-shield-keyhole-line", text: "身份最小化留存" },
  { icon: "ri-history-line", text: "更新留痕，可追溯" },
];

function Hero() {
  const latest = clues.slice(0, 6);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20editorial%20newsroom%20desk%20with%20scattered%20papers%20sealed%20envelopes%20and%20a%20single%20desk%20lamp%2C%20warm%20sepia%20and%20deep%20crimson%20accents%2C%20dramatic%20low%20light%20with%20soft%20glow%2C%20cinematic%20top%20down%20composition%2C%20no%20legible%20text&width=1800&height=1000&seq=hero-baoliao-01&orientation=landscape"
          alt="爆料平台匿名投稿与线索归档主视觉"
          title="爆料平台 - 匿名爆料入口与内部消息投稿处"
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85" />
      </div>

      <div className="relative z-10 w-full px-4 pb-0 pt-20 md:px-8 md:pt-28">
        <div className="mx-auto max-w-4xl animate-fade-up text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-label tracking-widest text-background-100 backdrop-blur">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-accent-400" />
            匿名 · 安全 · 可追溯
          </span>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-6xl">
            <span className="mb-3 block font-label text-sm font-medium tracking-[0.3em] text-accent-400 md:text-base">
              爆料平台
            </span>
            把手里的匿名材料
            <br className="hidden sm:block" />
            放到能被看见的地方
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-lg">
            聊天截图、内部通知、文件材料或身边线索，都可以在这里匿名提交。平台对内部消息、公众事件与维权内容统一归档归类，后续核实与更新在对应入口同步。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/submit"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-send-plane-fill" />
              立即匿名爆料
            </Link>
            <Link
              to="/clues"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-6 py-3.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
            >
              <i className="ri-article-line" />
              浏览线索归档
            </Link>
          </div>

          <ul className="mx-auto mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
            {trustPoints.map((point) => (
              <li key={point.text} className="flex items-center gap-2 text-xs text-background-200 md:text-sm">
                <span className="flex h-5 w-5 items-center justify-center text-accent-400">
                  <i className={point.icon} />
                </span>
                {point.text}
              </li>
            ))}
          </ul>
        </div>

        <div className="relative mt-14 overflow-hidden border-t border-background-50/15 py-4 md:mt-20">
          <div className="animate-marquee flex w-max items-center gap-10">
            {[...latest, ...latest].map((clue, index) => (
              <Link
                key={`${clue.slug}-${index}`}
                to={`/clue/${clue.slug}`}
                className="flex shrink-0 items-center gap-2.5 text-xs text-background-200 transition-colors hover:text-accent-400 md:text-sm"
              >
                <span className="whitespace-nowrap rounded-sm border border-accent-400/50 px-1.5 py-0.5 text-[10px] font-label text-accent-400">
                  {clue.categoryName}
                </span>
                <span className="whitespace-nowrap">{clue.title}</span>
                <span className="whitespace-nowrap text-background-400">{clue.date}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;